
import * as ActionType from '../../constants/constant_action_types';

const INITIAL_STATE = {
  data: {},
  generate_receipt : false
};

export default function purchaseOrderReducer( state = INITIAL_STATE, action ) {
  switch ( action.type ) {
    case ActionType.SET_PURCHASE_ORDER: {
      return {
        ...state, data: { ...action.data }
      };
    }

    case ActionType.CLEAR_PURCHASE_ORDER: {
      return {
        ...INITIAL_STATE
      }
    }

    case ActionType.GENERATE_PURCHASE_RECEIPT: {
      return {
        ...state, generate_receipt: action.generateReceipt
      }
    }

    default:
      return state;
  }
}